<template>
  <div class="sticky-top py-2">
    <m-category-wrapper @categories="findFirstCategory">
      <template v-slot="{categories}">
        <div class="row blur-effect">
          <swiper id="categories306-categories-slider" class="mySwiper w-100 px-5"
                  v-bind="swiperOptions" :navigation="true" :modules="modules">

            <template v-for="category in flatCategories(categories)" :key="category.id">
              <swiper-slide v-if="category.products_count > 0" class=" ">

                <div class="category-item "
                     :class="{'category-active':JSON.stringify(selectedCategory) === JSON.stringify([category.slug])}"
                     @click="selectCategory(category)">
                  <div class="text-center category-name-parent  ">
                    <img :src="category.image"
                         :alt="category.name" class="">
                    <span class="text-center">{{ category.name }}</span>
                  </div>
                </div>

              </swiper-slide>
            </template>


          </swiper>
        </div>
      </template>
    </m-category-wrapper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade} from 'swiper';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import {Navigation} from "swiper";
import mCategoryWrapper from "../../Wrappers/CategoryWrapper";
import {flatCategories,} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category'


export default {
  name: "Categories306",
  components: {Swiper, SwiperSlide, mCategoryWrapper},
  props:{
    swiperPerViewExtraSM: {
      type: Number,
      default: 2,
    },
    swiperPerViewSM: {
      type: Number,
      default: 4,
    },
    swiperPerViewMD: {
      type: Number,
      default: 6,
    },
    swiperPerViewLG: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      selectedCategory: [],
      swiperOptions: {
        breakpoints: {
          300: {
            slidesPerView: 2,
            spaceBetween: 70,
          },
          400: {
            slidesPerView: 3,
            spaceBetween: 70,
          },
          430: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
          490: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          520: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          768: {
            slidesPerView: 6,
            spaceBetween: 50,
          },
          980: {
            slidesPerView: 8,
            spaceBetween: 50,
          },
          1200: {
            slidesPerView: 9,

          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    }
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = []
      if (category !== '') {
        this.selectedCategory.push(category.slug)
        this.$emit('category', this.selectedCategory)
        return true
      }
      this.selectedCategory = null
      this.$emit('category', this.selectedCategory)
    },
    findFirstCategory(categories) {
      let check = true;
      categories = categories.data.data
      categories.forEach(item => {

        if (item.products_count > 0 && check) {
          check = false
          this.$store.commit('Product/setFilters', {key: 'category', value: [item.id]})
          this.selectedCategory = [item.slug]
          this.$emit('category', this.selectedCategory)
        }

      })

    },
    flatCategories,
  },
  setup() {
    return {
      modules: [Navigation, EffectFade],
    };
  },
  beforeMount() {
    this.swiperOptions.breakpoints["300"].slidesPerView = this.swiperPerViewExtraSM
    this.swiperOptions.breakpoints["400"].slidesPerView = this.swiperPerViewExtraSM
    this.swiperOptions.breakpoints["430"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["490"].slidesPerView = this.swiperPerViewSM

    this.swiperOptions.breakpoints["520"].slidesPerView = this.swiperPerViewMD
    this.swiperOptions.breakpoints["768"].slidesPerView = this.swiperPerViewMD

    this.swiperOptions.breakpoints["980"].slidesPerView = this.swiperPerViewLG
    this.swiperOptions.breakpoints["1200"].slidesPerView = this.swiperPerViewLG

  }
}
</script>


<style scoped>
.category-item {
  background: var(--dark) ;
  color: white ;
  cursor: pointer;
  width: 110px;
  border-radius: 4px;
  height: 100px;

  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-around;

}

.category-item img {
  height: auto;
  width: 50px;
  display: block;
  text-align: center;
  margin: auto;
}

.category-name-parent {
  font-size: 12px;
}


.blur-effect {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

</style>